import React, { Fragment, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { connect } from "react-redux";
import { useProducts } from "../../api";
import Navbar from "../../components/Navbar/Navbar";
import PageTitle from "../../components/pagetitle/PageTitle";
import Scrollbar from "../../components/scrollbar/scrollbar";
import { addToCart } from "../../store/actions/action";
import Product from "./product";
import ProductTabs from "./alltab";
import Footer from "../../components/footer/Footer";
import { useTranslation } from "react-i18next";
import {
  incrementQuantity,
  decrementQuantity,
} from "../../store/actions/action";

const ProductSinglePage = (props) => {
  const { slug } = useParams();
  const { t } = useTranslation();
  const { data: products = [], isLoading } = useProducts();
  const { addToCart, carts, incrementQuantity, decrementQuantity } = props;

  const product = products.find((p) => p.slug === slug);

  return (
    <Fragment>
      <Navbar />
      <PageTitle
        pageTitle={t(`productSingle`)}
        pagesub={t(`productSingle`)}
      />
      <section className="wpo-shop-single-section section-padding">
        <div className="container">
          {isLoading ? (
            <p>{t(`loading`)}</p>
          ) : product ? (
              <Product item={product} addToCart={addToCart} carts={carts} incrementQuantity={incrementQuantity} decrementQuantity={decrementQuantity} />
          ) : (
            <p>{t(`notFound`)}</p>
          )}
          <ProductTabs />
        </div>
      </section>
      <Footer ftClass={"s2"} />
      <Scrollbar />
    </Fragment>
  );
};
const mapStateToProps = (state) => {
  return {
    carts: state.cartList.cart,
  };
};

export default connect(mapStateToProps, {
  addToCart,
  incrementQuantity,
  decrementQuantity })(ProductSinglePage);
